import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {AlertTriangleIcon} from '@components/ui/icon.tsx'
import {ButtonLink} from '@components/commons/button-link'
import {routes} from '@utilities/constants/routes.tsx'
import {ServiceType} from '@features/assignment/types.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME
} from '@features/assignment/constants'

export const FirstAcceptNoLongerAvailableDescription = ({serviceType}: {serviceType: ServiceType}) => {
    const {t} = useTranslation()

    return (
        <div className="flex flex-col gap-6">
            <div className="flex items-center gap-4 self-start rounded-2xl bg-neutral-100 p-4 [&_p]:text-sm [&_p]:font-medium [&_p]:text-neutral-900">
                <AlertTriangleIcon size={20} className="text-warning-600" />
                <p>{t('assignment:first_accept:no_longer_available_banner')}</p>
            </div>
            <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-[1fr_auto] md:items-center">
                <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                    <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                        {t('assignment:first_accept:no_longer_available_title')}
                    </h3>
                    <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                        {t(`assignment:first_accept:no_longer_available_paragraph:${serviceType}` as TKey)}
                    </p>
                </div>
                <ButtonLink to={routes.HOME.handle.fullPath} variant="primary">
                    {t('assignment:first_accept:browse_assignments')}
                </ButtonLink>
            </div>
        </div>
    )
}
